const welcome = {
    title: 'Welcome to Identity Console',
    description: 'Identity Console is a web app to manage Cast Identity without coding requirements. Let’s first create an account. With this account, you can manage Cast Identity by yourself or on behalf of your company.',
    create_account: 'Create account',
};
export default Object.freeze(welcome);
